import { __rest } from "tslib";
import React from 'react';
import Icon from '../icon';
import Slot, { Slottable } from '../slot';
import { PopoverTrigger } from '../popover';
import { vars } from '~/theme/theme.css';
import { caret, trigger } from './dropdown-trigger.css';
import { cn, warn } from '~/utils';
import { useDropdownContext } from './dropdown-context';
import { usePopoverProvider } from '../popover/popover-context';
const DROPDOWN_TRIGGER_NAME = 'vulcanui-dropdown-trigger';
function DropdownTrigger(props) {
    const { children, compacted = false, className, asChild, hideCaret, fullWidth } = props, restProps = __rest(props, ["children", "compacted", "className", "asChild", "hideCaret", "fullWidth"]);
    const { disabled } = useDropdownContext('DropdownTrigger');
    const { open } = usePopoverProvider('DropdownTrigger');
    const Comp = asChild ? Slot : 'button';
    if (compacted && asChild)
        warn("compact prop doesn't work with asChild prop");
    return (React.createElement(PopoverTrigger, null,
        React.createElement(Comp, Object.assign({ "aria-disabled": disabled, className: cn(DROPDOWN_TRIGGER_NAME, className, {
                [trigger({ compacted, disabled, hasCaret: !hideCaret, expanded: open, fullWidth })]: !asChild
            }), "data-compacted": compacted, disabled: disabled, type: "button" }, restProps),
            React.createElement(Slottable, null, children),
            hideCaret || asChild ? null : (React.createElement("span", { className: cn(`vulcanui-${DROPDOWN_TRIGGER_NAME}-caret`, caret({ compacted })) },
                React.createElement(Icon, { name: "caret-down", type: "solid", color: vars.colors['default-500'] }))))));
}
DropdownTrigger.displayName = 'Dropdown.Trigger';
DropdownTrigger.toString = () => `.${DROPDOWN_TRIGGER_NAME}`;
export default DropdownTrigger;
//# sourceMappingURL=dropdown-trigger.js.map